import { isUndefined } from 'lodash';
import { AccountDto, AccountTypeDto } from 'src/dtos';
import {
  Account,
  AccountFinancialAssets,
  AccountHolderAddress,
  AccountSuitabilityInformation,
  AccountType,
  EntityAccountType,
  JointAccountType,
  RetirementAccountType,
} from 'src/models';
import { getUnitedStateOptionLabel } from 'src/utils';

import { mapAccountHolderDtoToModel } from './accountHolders.mappers';

export const mapAccountDtoToModel = (dto: AccountDto): Account => {
  const type = new AccountType(dto.type);

  let secondaryAccountHolder = dto.secondaryAccountHolder;

  if (type.isEntity && dto.otherAccountHolders && dto.otherAccountHolders.length > 0) {
    secondaryAccountHolder = dto.otherAccountHolders[0];
  }

  return {
    id: dto.id,
    type: new AccountType(dto.type),
    jointAccountType: new JointAccountType(dto.jointAccountType),
    jointCommunityPropertyState: dto.jointCommunityPropertyState
      ? { label: getUnitedStateOptionLabel(dto.jointCommunityPropertyState), value: dto.jointCommunityPropertyState }
      : undefined,
    accountId: dto.accountId,
    accountNumber: dto.accountNumber,
    primaryAccountHolder: dto.primaryAccountHolder && mapAccountHolderDtoToModel(dto.primaryAccountHolder),
    secondaryAccountHolder: secondaryAccountHolder && mapAccountHolderDtoToModel(secondaryAccountHolder), // TODO: pass authroized signer 2 as secondary account holder if found in enttiy account
    retirementAccountType: dto.retirementAccountType ? new RetirementAccountType(dto.retirementAccountType) : undefined,
    simpleIraPlanName: dto.simpleIraPlanName,
    beneficiaryIraDecedentName: dto.beneficiaryIraDecedentName,
    beneficiaries: dto.beneficiaries ?? [],
    entityAccountType: dto.entityAccountType ? new EntityAccountType(dto.entityAccountType) : undefined,
    isEntityAccountTypeActive: dto.type === AccountTypeDto.Entity ? !isUndefined(dto.accountNumber) : undefined,
    otherAccountHolders:
      dto.otherAccountHolders?.filter((holder, index) => index > 0).map(mapAccountHolderDtoToModel) ?? [],
    entityInformation: dto.entityInformation
      ? { ...dto.entityInformation, address: new AccountHolderAddress(dto.entityInformation.address) }
      : undefined,
    applicationId: dto.applicationId,
    suitabilityInformation: dto.suitabilityInformation
      ? new AccountSuitabilityInformation(dto.suitabilityInformation)
      : undefined,
    financialAssets: dto.financialAssets ? new AccountFinancialAssets(dto.financialAssets) : undefined,
    isAccredited: dto.isAccredited,
  };
};
